import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { Clock, LogOut } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Spinner } from '@/components/ui/spinner'
import { authApi } from '@/services/auth'
import { billingApi } from '@/services/billing'
import { getErrorMessage } from '@/lib/api'

export default function TrialExpiredPage() {
  const navigate = useNavigate()
  const [isRedirecting, setIsRedirecting] = useState(false)

  const onUpgrade = async () => {
    setIsRedirecting(true)
    try {
      const { checkout_url } = await billingApi.createCheckoutSession()
      window.location.href = checkout_url
    } catch (error) {
      toast.error(getErrorMessage(error))
      setIsRedirecting(false)
    }
  }

  const onSignOut = async () => {
    await authApi.logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-primary/5 px-4 py-10">
      <Card className="w-full max-w-md border-primary/20 shadow-xl">
        <CardHeader className="items-center text-center">
          <div className="mb-2 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Clock className="h-7 w-7" />
          </div>
          <CardTitle className="text-xl">Your free trial has ended</CardTitle>
          <CardDescription>
            Upgrade now to keep using your account with no interruption to your data or setup.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button type="button" className="w-full" disabled={isRedirecting} onClick={onUpgrade}>
            {isRedirecting ? <Spinner className="mr-2" /> : null}
            Upgrade now
          </Button>
          <Button type="button" variant="outline" className="w-full" onClick={onSignOut}>
            <LogOut className="mr-2 h-4 w-4" />
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
